import { render, staticRenderFns } from "./TabletMenuEntry.vue?vue&type=template&id=5a80da09&"
import script from "./TabletMenuEntry.vue?vue&type=script&lang=js&"
export * from "./TabletMenuEntry.vue?vue&type=script&lang=js&"
import style0 from "./TabletMenuEntry.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
